$.fn.sideSlideCallbacks.opened = function(){
    $('.hamburger').toggleClass("is-active");
};

$.fn.sideSlideCallbacks.closed = function(){
    $('.hamburger').toggleClass("is-active");
};